const CLICK_STORAGE_KEY = "lophocdan_meta_click_v1"
const MAX_CLICK_AGE_MS = 90 * 24 * 60 * 60 * 1000
const CAMPAIGN_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "gbraid", "wbraid"]
const META_FIELDS = ["fbclid", "fbclid_captured_at", "fbc", "fbp", "event_source_url", "client_user_agent"]
let observedClick

function readCookie(name) {
  try {
    const cookie = document.cookie.split(";").map(value => value.trim()).find(value => value.startsWith(`${name}=`))
    return cookie ? decodeURIComponent(cookie.slice(name.length + 1)) : null
  } catch {
    return null
  }
}

function validMetaCookie(value) {
  return typeof value === "string" && /^fb\.\d+\.\d{13}\.[A-Za-z0-9_.-]+$/.test(value) && value.length <= 2048
}

function readStoredClick(now) {
  let click = observedClick
  try {
    click = JSON.parse(localStorage.getItem(CLICK_STORAGE_KEY)) || click
  } catch {
    // Attribution still works during this page visit when storage is unavailable.
  }
  const capturedAt = Number(click?.fbclid_captured_at)
  if (!validMetaCookie(click?.fbc) || !Number.isFinite(capturedAt) || capturedAt > now || now - capturedAt > MAX_CLICK_AGE_MS) return null
  if (click.fbc.split(".").slice(3).join(".") !== click.fbclid || Number(click.fbc.split(".")[2]) !== capturedAt) return null
  return click
}

export function browserAttribution() {
  const now = Date.now()
  const page = new URL(window.location.href)
  page.hash = ""
  const candidate = page.searchParams.get("fbclid")
  const currentId = candidate && /^[A-Za-z0-9_.-]{1,1800}$/.test(candidate) ? candidate : null
  const cookie = readCookie("_fbc")
  const cookieTime = Number(cookie?.split(".")[2])
  const cookieParts = validMetaCookie(cookie) && cookieTime <= now && now - cookieTime <= MAX_CLICK_AGE_MS ? cookie.split(".") : null
  const cookieId = cookieParts?.slice(3).join(".")
  const stored = readStoredClick(now)
  let click = stored

  if (currentId) {
    // A new URL click must not inherit a previous ad's cookie. Reuse the first
    // observation for the same click across Turbo visits and full reloads.
    const matchingCookie = cookieId === currentId
    const capturedAt = matchingCookie ? Number(cookieParts[2]) : (stored?.fbclid === currentId ? stored.fbclid_captured_at : now)
    click = { fbclid: currentId, fbclid_captured_at: capturedAt, fbc: matchingCookie ? cookie : `fb.1.${capturedAt}.${currentId}` }
  } else if (cookieParts && (!stored || Number(cookieParts[2]) >= Number(stored.fbclid_captured_at))) {
    click = { fbclid: cookieId, fbclid_captured_at: Number(cookieParts[2]), fbc: cookie }
  }

  if (click) {
    observedClick = click
    try {
      localStorage.setItem(CLICK_STORAGE_KEY, JSON.stringify(click))
    } catch {
      // Do not block registration when browser storage is disabled.
    }
  }

  // CRM only needs the page identity here; query strings can contain contact
  // details or access tokens. Advertising parameters travel in separate fields.
  const fields = { ...click, event_source_url: `${page.origin}${page.pathname}`, client_user_agent: navigator.userAgent }
  const fbp = readCookie("_fbp")
  if (validMetaCookie(fbp)) fields.fbp = fbp
  for (const name of CAMPAIGN_FIELDS) {
    const value = page.searchParams.get(name)
    if (value) fields[name] = value
  }
  return fields
}

export function attributedTallyUrl(value, fields = browserAttribution()) {
  let url
  try {
    url = new URL(value, window.location.href)
  } catch {
    return null
  }
  if (url.origin !== "https://tally.so" || !/^\/(?:embed|r)\/[A-Za-z0-9]+\/?$/.test(url.pathname)) return null
  for (const name of META_FIELDS) url.searchParams.delete(name)
  for (const [name, field] of Object.entries(fields)) {
    if (field) url.searchParams.set(name, field)
  }
  return url.toString()
}
